import DialogInOne from "src/components/DialogInOne";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import ViewGroupDialogContent from "../components/ViewGroupDialogContent";
import { ViewGroupData } from "../types/ViewGroupData";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  viewGroupData: ViewGroupData;
};

const useViewGroupDialog = (props: Props) => {
  const { isOpen, viewGroupData, onClose } = props;
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);

  const renderViewGroupDialog = () => {
    return (
      <DialogInOne
        title={t("view_contract_sweep_recipient_group")}
        self={{
          open: isOpen,
          onClose: onClose,
        }}
        maxWidth="xl"
        content={
          <ViewGroupDialogContent
            viewGroupData={viewGroupData}
            isOpen={isOpen}
          />
        }
        isConfirmHidden
        onConfirm={() => {}}
        onCancel={onClose}
        rest={{
          sx: {
            "& .MuiPaper-root": {
              width: "100vw",
              margin: 0,
            },
          },
        }}
      />
    );
  };

  return { renderViewGroupDialog };
};

export default useViewGroupDialog;
